import React, { useRef, useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { Divider } from 'primereact/divider';
import { InputText } from 'primereact/inputtext';
import { Ripple } from 'primereact/ripple';
import { Menu } from 'primereact/menu';
import { Menubar } from 'primereact/menubar';
import { Avatar } from 'primereact/avatar';
import { Dialog } from 'primereact/dialog';
import AuthModal from './AuthModal';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useCart } from '../../contexts/CartContext';
import ThemeToggle from '../common/ThemeToggle';
import SearchInput from '../common/SearchInput';
import toast from 'react-hot-toast';

const Header = ({ theme, onToggleTheme }) => {
    const navigate = useNavigate();
    const { user, isAuthenticated, logout } = useAuth();
    const { itemCount } = useCart();
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
    const [userMenuVisible, setUserMenuVisible] = useState(false);
    const [loginVisible, setLoginVisible] = useState(false);
    const userMenuRef = useRef(null);
    const btnRef31 = useRef(null);
    const siteUrl = process.env.REACT_APP_SITE_URL || '';

    const goTo = (path) => window.location.assign(`${siteUrl}${path}`);

    const catalogMenuItems = [
        { label: 'Catálogo', icon: 'pi pi-th-large', command: () => goTo('/catalogo') },
        { label: 'Laptops', icon: 'pi pi-desktop', command: () => goTo('/catalogo/laptops') },
        { label: 'Gaming', icon: 'pi pi-bolt', command: () => goTo('/catalogo/laptops/gaming') },
        { label: 'WorkStations', icon: 'pi pi-server', command: () => goTo('/catalogo/laptops/workstation') },
        { label: 'Empresarial', icon: 'pi pi-building', command: () => goTo('/catalogo/laptops/profesional-y-corporativo') },
        { label: 'Tablets', icon: 'pi pi-mobile', command: () => goTo('/catalogo/tablets') },
        { label: 'Monitores', icon: 'pi pi-video', command: () => goTo('/catalogo/monitores') },
        { label: 'Coolers', icon: 'pi pi-cog', command: () => goTo('/catalogo/cooler') },
        { label: 'Mouses', icon: 'pi pi-stop', command: () => goTo('/catalogo/mouses') },
        { label: 'Mochilas', icon: 'pi pi-briefcase', command: () => goTo('/catalogo/mochilas') },
        { label: 'Auriculares', icon: 'pi pi-volume-up', command: () => goTo('/catalogo/auriculares') },
    ];

    const handleLogout = () => {
        logout();
        toast.success('Sesión cerrada exitosamente');
        navigate('/');
    };

    const handleAuthSuccess = () => {
        setLoginVisible(false);
        toast.success('Bienvenido');
    };

    const userMenuItems = [
        {
            label: 'Mi Perfil',
            icon: 'pi pi-user',
            command: () => navigate('/perfil')
        },
        {
            label: 'Mis Pedidos',
            icon: 'pi pi-shopping-bag',
            command: () => navigate('/pedidos')
        },
        {
            separator: true
        },
        {
            label: 'Cerrar Sesión',
            icon: 'pi pi-sign-out',
            command: handleLogout
        }
    ];

    return (
        <>
            {/* Banner superior (solo desktop) */}
            <div className="hidden lg:flex bg-black-alpha-90 text-cyan-600 relative align-items-center" style={{ minHeight: '32px' }}>
                <div className="hidden lg:flex absolute lg:static left-0 top-100 z-1 shadow-2 lg:shadow-none">
                    <ul className="flex list-none p-0 m-0 flex-column lg:flex-row">
                        <li className="h-full">
                            <a href="/nosotros" className="p-ripple cursor-pointer h-full inline-flex align-items-center border-left-2 lg:border-left-none lg:border-bottom-2 border-cyan-500 transition-colors transition-duration-150 py-3 lg:py-0 px-3">
                                <span className="font-medium">Nosotros</span>
                                <Ripple />
                            </a>
                        </li>
                        {/* <li className="h-full">
                            <a className="p-ripple cursor-pointer h-full inline-flex align-items-center border-left-2 lg:border-left-none lg:border-bottom-2 border-transparent hover:border-500 transition-colors transition-duration-150 py-3 lg:py-0 px-3">
                                <span className="font-medium">Blog</span>
                                <Ripple />
                            </a>
                        </li> */}
                        <li className="h-full">
                            <a href="/contacto" className="p-ripple cursor-pointer h-full inline-flex align-items-center border-left-2 lg:border-left-none lg:border-bottom-2 border-transparent hover:border-500 transition-colors transition-duration-150 py-3 lg:py-0 px-3">
                                <span className="font-medium">Contacto</span>
                                <Ripple />
                            </a>
                        </li>
                        <li className="h-full">
                            <a href="/faq" className="p-ripple cursor-pointer h-full inline-flex align-items-center border-left-2 lg:border-left-none lg:border-bottom-2 border-transparent hover:border-500 transition-colors transition-duration-150 py-3 lg:py-0 px-3">
                                <span className="font-medium">FAQs</span>
                                <Ripple />
                            </a>
                        </li>
                    </ul>
                </div>

                {/* Banner de promociones */}
                <div className="flex-1 flex justify-content-center overflow-hidden position-relative" style={{ height: '32px' }}>
                    <div className="banner-scroll">
                        <ul className="banner-list text-cyan-400">
                            <li className="banner-item">Ahorra comprando con transferencia directa</li>
                            <li className="banner-item">Envíos gratis en algunos productos</li>
                            <li className="banner-item">Descuentos especiales para clientes frecuentes</li>
                            <li className="banner-item">Soporte técnico 24/7 disponible</li>
                            <li className="banner-item">Garantía extendida en todos los productos</li>
                            <li className="banner-item">Múltiples métodos de pago disponibles</li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Navegación principal */}
            <nav className="surface-section py-1 px-4 md:px-6 shadow-2 relative md:static border-bottom-1 surface-border" style={{ minHeight: '84px', zIndex: 50 }}>
                {/* Fila superior móvil: logo y hamburguesa */}
                <div className="flex align-items-center justify-content-between md:hidden">
                    <a href="/" className="block">
                        <img
                            src={theme === 'light' ? '/logotipo-hor-light.png' : '/logotipo-hor-dark.png'}
                            alt="Laptops.pe"
                            height="48"
                            className="mr-0"
                        />
                    </a>
                    <a className="p-ripple cursor-pointer text-primary" aria-label="Abrir menú" onClick={() => setMobileMenuVisible(v => !v)}>
                        <i className="pi pi-bars text-3xl"></i>
                        <Ripple />
                    </a>
                </div>

                {/* Búsqueda debajo del logo en móviles */}
                <div className="md:hidden mt-2">
                    <SearchInput placeholder="Buscar productos..." className="w-full" />
                </div>

                {/* Fila desktop: logo, búsqueda y acciones (md+) */}
                <div className="hidden md:flex align-items-center justify-content-between gap-4">
                    {/* Logo */}
                    <a href="/" className="block">
                        <img
                            src={theme === 'light' ? '/logotipo-hor-light.png' : '/logotipo-hor-dark.png'}
                            alt="Laptops.pe"
                            height="60"
                            className="mr-2"
                        />
                    </a>
                    {/* Barra de búsqueda (ocupa espacio disponible) */}
                    <div className="flex-1 mx-2">
                        <SearchInput placeholder="Buscar productos, marcas, modelos..." className="w-full" inputClassName="w-full" />
                    </div>
                    {/* Acciones del usuario */}
                    <div className="flex align-items-center gap-2">
                        {/* Toggle de tema */}
                        <ThemeToggle theme={theme} onToggle={onToggleTheme} />

                        {/* Favoritos */}
                        {/*<Button
                            icon="pi pi-heart"
                            className="p-button-text p-button-rounded"
                            tooltip="Favoritos"
                            size='large'
                            tooltipOptions={{ position: 'bottom' }}
                        />*/}

                        {/* Comparar */}
                        {/*<Button
                            icon="pi pi-clone"
                            className="p-button-text p-button-rounded"
                            tooltip="Comparar"
                            size='large'
                            tooltipOptions={{ position: 'bottom' }}
                        />

                        {/* Carrito */}
                        {/*<Button
                            className="p-button-text p-button-rounded"
                            onClick={() => navigate('/carrito')}
                            tooltip="Carrito de compras"
                            size="large"
                            tooltipOptions={{ position: 'bottom' }}
                        >
                            <i className="pi pi-shopping-cart p-overlay-badge" style={{ fontSize: '1.6rem' }}>
                                {/* Desktop: número */}
                        {/*{itemCount > 0 && (
                                    <span className="hidden md:inline">
                                        <Badge value={itemCount > 99 ? '99+' : itemCount} severity="danger"></Badge>
                                    </span>
                                )}*/}
                        {/* Móvil: punto */}
                        {/*{itemCount > 0 && (
                                    <span className="inline md:hidden">
                                        <Badge severity="danger"></Badge>
                                    </span>
                                )}
                            </i>
                        </Button>*/}

                        {/* Usuario */}
                        {/*{isAuthenticated ? (
                            <div className="relative">
                                <Button
                                    icon="pi pi-user"
                                    label={`Hola, ${user?.nombre || user?.name || user?.email || ''}`}
                                    className="p-button-text p-button-rounded"
                                    onClick={(e) => userMenuRef.current.toggle(e)}
                                    tooltipOptions={{ position: 'bottom' }}
                                />
                                <Menu
                                    ref={userMenuRef}
                                    model={userMenuItems}
                                    popup
                                    appendTo={typeof document !== 'undefined' ? document.body : null}
                                />
                            </div>
                        ) : (
                            <div className="flex gap-2">
                                <Button
                                    label="Iniciar Sesión"
                                    icon="pi pi-sign-in"
                                    className="p-button-raised p-button-primary p-button-rounded"
                                    onClick={() => setLoginVisible(true)}
                                />
                            </div>
                        )}*/}
                    </div>
                </div>

                {/* Menú catálogo (segunda fila, visible solo en md+) */}
                <div className="hidden md:block pt-2">
                    <div className="w-full">
                        <Menubar model={catalogMenuItems} className="border-none surface-0 w-full" />
                    </div>
                </div>

                {/* Menú móvil (desplegable, ancho completo) */}
                {mobileMenuVisible && (
                    <div className="md:hidden absolute left-0 top-100 w-full surface-section shadow-2 border-1 surface-border" style={{ zIndex: 1000, backgroundColor: 'var(--surface-section, #fff)' }}>
                        <div className="p-4">
                            {/* Opciones de catálogo */}
                            <div className="flex flex-column gap-2">
                                {catalogMenuItems.map((item, i) => (
                                    <Button
                                        key={i}
                                        label={item.label}
                                        icon={item.icon}
                                        className="w-full justify-content-start"
                                        onClick={item.command}
                                    />
                                ))}
                            </div>

                            <Divider />

                            {/* Acciones de usuario */}
                            <div className="flex flex-column gap-2 mt-3">
                                <Button label="Carrito" icon="pi pi-shopping-cart" className="w-full justify-content-start" onClick={() => navigate('/carrito')} badge={itemCount > 0 ? itemCount.toString() : null} />
                                {isAuthenticated ? (
                                    <>
                                        <Button label="Mi Perfil" icon="pi pi-user" className="w-full justify-content-start" onClick={() => navigate('/perfil')} />
                                        <Button label="Cerrar Sesión" icon="pi pi-sign-out" className="w-full justify-content-start" onClick={handleLogout} />
                                    </>
                                ) : (
                                    <>
                                        <Button label="Iniciar Sesión" icon="pi pi-sign-in" className="w-full justify-content-start" onClick={() => setLoginVisible(true)} />
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </nav>

            {/* Modal de Iniciar Sesión (AuthModal compartido) */}
            <AuthModal
                visible={loginVisible}
                onHide={() => setLoginVisible(false)}
                onAuthSuccess={handleAuthSuccess}
            />

            <style jsx="true">{`
                .banner-scroll {
                    display: flex;
                    align-items: center;
                    height: 100%;
                    width: 100%;
                    overflow: hidden;
                }
                
                .banner-list {
                    display: flex;
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    white-space: nowrap;
                    animation: scroll-continuous 40s linear infinite;
                    will-change: transform;
                    min-width: max-content;
                }
                
                .banner-item {
                    font-size: 14px;
                    font-weight: 500;
                    white-space: nowrap;
                    margin-right: 4rem;
                    display: flex;
                    align-items: center;
                    flex-shrink: 0;
                }
                
                .banner-item:before {
                    content: '•';
                    margin-right: 0.5rem;
                    color: var(--primary-color);
                    font-weight: bold;
                }
                
                @keyframes scroll-continuous {
                    0% {
                        transform: translateX(100%);
                    }
                    100% {
                        transform: translateX(-100%);
                    }
                }
                
                .banner-scroll:hover .banner-list {
                    animation-play-state: paused;
                }
            `}</style>

            {/* Menú catálogo se integra en la fila desktop (ver arriba) */}
        </>
    );
};

export default Header;
